import React from 'react';
import { services } from '../mockData';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

const MainServices = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16 max-w-4xl mx-auto">
          <div className="inline-block bg-gray-100 text-notaria-secondary px-6 py-2 rounded-full mb-4 text-sm font-semibold animate-fade-in">
            Nuestros Servicios
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-notaria-primary mb-6 animate-fade-in">
            Unimos la experiencia notarial con la transparencia del blockchain
          </h2>
          <p className="text-lg text-gray-700">
            La solidez notarial se encuentra con la transparencia del blockchain para dar certeza absoluta a tus trámites.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-7xl mx-auto">
          {services.map((service, index) => (
            <Card 
              key={service.id} 
              className="overflow-hidden border-2 border-gray-100 hover:border-notaria-secondary transition-all duration-500 hover:shadow-2xl group bg-white"
            >
              <CardContent className="p-0">
                {/* Image */}
                <div className="relative h-72 overflow-hidden bg-gradient-to-br from-notaria-primary to-notaria-secondary">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-110 transition-all duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-notaria-primary/90 via-notaria-primary/50 to-transparent"></div>
                  
                  {/* Service Number Badge */}
                  <div className="absolute top-4 right-4 w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center border-2 border-white/40">
                    <span className="text-white font-bold text-lg">{service.id}</span>
                  </div>

                  {/* Title Overlay */}
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <div className="text-cyan-400 text-sm font-semibold mb-2 uppercase tracking-wide">
                      {service.title}
                    </div>
                    <h3 className="text-2xl font-bold text-white">
                      {service.subtitle}
                    </h3>
                  </div>
                </div>

                {/* Content */}
                <div className="p-8 bg-white">
                  <ul className="space-y-3 mb-6">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start gap-3 text-gray-700">
                        <div className="w-1.5 h-1.5 bg-notaria-secondary rounded-full mt-2 flex-shrink-0"></div>
                        <span className="text-sm leading-relaxed">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <Button
                    variant="outline"
                    className="w-full text-notaria-secondary border-notaria-secondary hover:bg-notaria-secondary hover:text-white transition-all duration-300 group/btn"
                  >
                    Conoce más
                    <ArrowRight className="ml-2 w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MainServices;
